import { useState, useEffect } from 'react'
import { firestore } from '@/lib/firebase'

const collectionRef = firestore.collection('coupons')

export const useCoupons = () => {
  const [coupons, setCoupons] = useState<App.Coupon[]>([])

  useEffect(() => {
    return collectionRef.onSnapshot(async a => {
      const p = await Promise.all(
        a.docs.map<Promise<App.Coupon>>(async b => {
          const data = b.data()
          return {
            ...data,
            id: b.id,
          } as App.Coupon
        }),
      )
      setCoupons(p)
    })
  }, [])

  return coupons
}
